import { LinkBreak2Icon } from '@radix-ui/react-icons';
import { useEffect, useState, VideoHTMLAttributes, type JSX } from 'react';

import { cn } from '../../utils/cn';

interface VideoProps extends VideoHTMLAttributes<HTMLVideoElement> {
  fallback?: JSX.Element;
}

export function Video({
  className,
  controls = false,
  fallback,
  onError,
  src,
  ...props
}: VideoProps) {
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    setIsBroken(false);
  }, [src]);

  if (isBroken) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (fallback) return <>{fallback}</>;

    return (
      <div className={cn('flex items-center justify-center text-muted-foreground', className)}>
        <LinkBreak2Icon />
      </div>
    );
  }

  return (
    <video className={className} controls={controls} {...props}>
      <source src={src} type="video/mp4" onError={() => setIsBroken(true)} />
    </video>
  );
}
